// extracted by mini-css-extract-plugin
module.exports = {"preferences":"index-module--preferences--3UU38","icon":"index-module--icon--2j_Hy","preferencesDetails":"index-module--preferencesDetails--3JHbW"};